import { type NewCoreIconProps } from '@atlaskit/icon';
import AtlaskitDatabaseIcon from '@atlaskit/icon/core/database';
import React from 'react';

export const DatabaseIcon = (props: NewCoreIconProps) => {
  return <AtlaskitDatabaseIcon spacing="spacious" {...props} />;
};

export default DatabaseIcon;
